import FORM from "../../components/report/form/form"

export default {
    container: undefined,
    buildContent(station_prefix_id,container){
        this.container = container
        FORM.build('StationPrefix',container,station_prefix_id)
    }
}